module.exports = __webpack_public_path__ + "img/编组 5.a4fcb6b6.png";